import { Yii } from "libraries/interfaces/Yii";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { NotificationType } from "libraries/interfaces/INotification";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { ISelectOption } from "libraries/module/formbuilder/fieldsets/generic-fieldset.component";

export enum EImportMode {
    simple = 'simple',
    multiple = 'multiple'
}

export interface ISimpleBookingImport {
    hostName: string;
    bookingCode : string;
}

export interface INotificationImport {
    success: {
        isNotification: boolean;
        message: string;
        notificationType: NotificationType;
    };
    error: {
        isNotification: boolean;
        message: string[]
        notificationType: NotificationType;
    };
}

export interface IImportQueryParam {
    host: string[];
    code: string[];
    mode: EImportMode;

}

export interface IFieldConfig {
    hostName?: {
        config: IFieldSpecs;
        items: ISelectOption[];
    };
    bookingCode?: {
        config: IFieldSpecs;
    };
    text?: {
        config: IFieldSpecs;
    };
}

export const CODE_COLUMN_NAME: string[] = ['REFERENCE','CODE'];
export const HOST_COLUMN_NAME: string[] = ['HOST'];

export const WORDING_IMPORT_FIELD: {[key:string]: string} = {
    hostName: Yii.t('wui-sasha-js', "Host"),
    bookingCode : Yii.t('wui-sasha-js', "Référence externe"),
    multipleImport: Yii.t('wui-sasha-js', "Host et référence des dossier à importer")
};


export const DESCRIPTION_IMPORT_FIELD: { [key: string]: IDescriptionLabels } = {
    hostName: {
        main: Yii.t('wui-sasha-js', "Host du dossier à importer"),
    },
    bookingCode : {
        main: Yii.t('wui-sasha-js', "Référence externe du dossier à importer"),
    },
    multipleImport: {
        main: Yii.t('wui-sasha-js', "Host et référence externe des dossier à importer"),
        detailIntroduction: Yii.t('wui-sasha-js', "Importer un dossier à partir de sa référence externe et de son code :"),
        detailList: [
            Yii.t('wui-sasha-js', "HOST CODE"),
            Yii.t('wui-sasha-js', "HOST,CODE"),
            Yii.t('wui-sasha-js', "HOST/CODE"),
            Yii.t('wui-sasha-js', "HOST.CODE"),
        ]
    },
};


